module.exports = __webpack_public_path__ + "media/images/download/e-book07-62086b67aa10e5ee2961db2f95f93544.png";